import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import SearchFilterRequest from '../../../Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest';
import BreathingUpdateRequest from '../../../Spirit/Admin/Interfaces/Models/BreathingService/BreathingUpdateRequest';
import ChangeSortIndexRequest from '../../../Spirit/Common/Helpers/Models/ChangeSortIndexRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import BreathingGetDetailResponse from '../../../Spirit/Admin/Interfaces/Models/BreathingService/BreathingGetDetailResponse';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import BreathingGetListResponse from '../../../Spirit/Admin/Interfaces/Models/BreathingService/BreathingGetListResponse';

export default class BreathingService {
	webApiService: WebApiService;
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();
	GetDetailEvent = new Events<WsResponseModelT<BreathingGetDetailResponse>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<BreathingGetListResponse>>>();
	UpdateEvent = new Events<WsResponseModelT<Boolean>>();
	ChangeSortIndexEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('BreathingService', 'Delete', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('BreathingService', 'GetDetail', (res: WsResponseModelT<BreathingGetDetailResponse>) => {
			self.GetDetailEvent.trigger(res);
		});
		webApiService.on('BreathingService', 'GetList', (res: WsResponseModelT<PaginationResponseT<BreathingGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('BreathingService', 'Update', (res: WsResponseModelT<Boolean>) => {
			self.UpdateEvent.trigger(res);
		});
		webApiService.on('BreathingService', 'ChangeSortIndex', (res: WsResponseModelT<Boolean>) => {
			self.ChangeSortIndexEvent.trigger(res);
		});
	}
	Delete(id: number = 0) { 	
        this.webApiService.send('BreathingService', 'Delete' , id);
    }
	GetDetail(id: number = 0) { 	
        this.webApiService.send('BreathingService', 'GetDetail' , id);
    }
	GetList(request: SearchFilterRequest = null) { 	
        this.webApiService.send('BreathingService', 'GetList' , request);
    }
	Update(request: BreathingUpdateRequest = null) { 	
        this.webApiService.send('BreathingService', 'Update' , request);
    }
	ChangeSortIndex(request: ChangeSortIndexRequest = null) { 	
        this.webApiService.send('BreathingService', 'ChangeSortIndex' , request);
    }
	 // async methods
	async deleteAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getDetailAsync(id: number = 0): Promise<BreathingGetDetailResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDetail.bind(this), this.GetDetailEvent)(id);
	}
	async getListAsync(request: SearchFilterRequest = null): Promise<PaginationResponseT<BreathingGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async updateAsync(request: BreathingUpdateRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Update.bind(this), this.UpdateEvent)(request);
	}
	async changeSortIndexAsync(request: ChangeSortIndexRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeSortIndex.bind(this), this.ChangeSortIndexEvent)(request);
	}
}